// extracted by mini-css-extract-plugin
export default {"menuIcon":"MenuIcon_menuIcon__JrHHo","line":"MenuIcon_line__uesQ6","openMenu":"MenuIcon_openMenu__Y-Ic-","text":"MenuIcon_text__S5kdy"};